<template>
  <LayoutDashboard title="Propostas">
    <v-card outlined>
      <v-card-title>
        <!-- <v-btn color="primary" outlined @click="cadastrarCrmProposta()"
          >Cadastrar</v-btn
        > -->
        <v-spacer></v-spacer>
        <h3>Registros: {{ getCrmPropostas.total }} -</h3>
        <v-pagination
          outlined
          total-visible="7"
          v-model="getCrmPropostas.current_page"
          :length="getCrmPropostas.last_page"
          @input="listarCrmPropostas({ ...dataPagina, page: $event })"
        ></v-pagination>
      </v-card-title>
      <v-card-text>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th width="10%">#</th>
                <th width="10%">
                  <v-text-field
                    v-model="dataPagina.propostaId"
                    outlined
                    dense
                    label="Código Venda"
                    class="mt-2"
                    @input="debouncedPesquisar()"
                  ></v-text-field>
                </th>
                <th>
                  <v-text-field
                    v-model="dataPagina.cliente"
                    outlined
                    dense
                    label="Cliente"
                    class="mt-2"
                    @input="debouncedPesquisar()"
                  ></v-text-field>
                </th>
                <th width="10%">
                  <v-text-field
                    v-model="dataPagina.proximo_contato"
                    outlined
                    dense
                    label="Próximo Contato"
                    class="mt-2"
                    type="date"
                    @input="debouncedPesquisar()"
                  ></v-text-field>
                </th>
                <th>
                  <v-select
                    :items="['',...getCrmPropostaStatus]"
                    v-model="dataPagina.status"
                    label="Status"
                    outlined
                    dense
                    class="mt-2"
                    @input="debouncedPesquisar()"
                  ></v-select>
                </th>
                <th width="10%" align="center">
                  <v-select
                    outlined
                    label="Exibir"
                    dense
                    :items="[10, 20, 30, 40, 50]"
                    item-value="value"
                    item-text="label"
                    v-model="dataPagina.limit"
                    @change="listarCrmPropostas({ ...dataPagina })"
                    class="mt-2"
                  ></v-select>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="p in getCrmPropostas.data" :key="p.id">
                <td>{{p.id}}</td>
                <td align="center">{{ p.proposta_id }}</td>
                <td>{{ p.proposta.cliente ? p.proposta.cliente.nome : '' }}</td>
                <td align="center">{{ $helper.formatDate(p.proximo_contato) }}</td>
                <td>{{p.status}}</td>
                <td align="center">
                  <TooltipButton
                    @click.native="visualizar(p)"
                    classButton="ml-2"
                    subtitle="Visualizar"
                    icon="search"
                    color="primary"
                    v-if="$helper.verificaPermissao('visualizar-propostas-crm')"
                  />
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-card-actions> </v-card-actions>
    </v-card>
    <!-- <ModalCadastro /> -->
    <ModalVisualizarVenda />
    <ModalVisualizar />

    
  </LayoutDashboard>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ModalVisualizarVenda from "@/pages/venda/ModalVisualizar"
import ModalVisualizar from "@/pages/crm/proposta/ModalVisualizar"
// import CrmPropostaAtividadeService from "@/services/CrmPropostaAtividadeService"
// import ModalCadastro from "@/pages/crm/proposta/ModalCadastro";
var _ = require("lodash");

export default {
  components: {
    // ModalCadastro,
    ModalVisualizarVenda,
    ModalVisualizar
  },
  data() {
    return {
      dataPagina: {
        id: "",
        propostaId: "",
        cliente: "",
        proximo_contato: "",
        status: "",
        // funcionaio_id: "",
        page: "",
        limit: 20,
      },
    };
  },
  computed: {
    ...mapGetters(["getCrmPropostas", "getCrmPropostaStatus"]),
  },
  methods: {
    ...mapActions(["cadastrarCrmProposta", "listarCrmPropostas", "visualizarCrmProposta", "setModalAtualizarTabelaCrmProposta", "visualizarVenda"]),
    pesquisar() {
      this.listarCrmPropostas(this.dataPagina);
    },
    visualizar(proposta){
      this.visualizarCrmProposta(proposta)
      // .then(res => {
      //   CrmPropostaAtividadeService.listar({...proposta})
      //   .then(res => {
      //     this.$store.commit('setAtividadesCrmProposta', res.data)
      //   })
      //   .catch(e => {
      //     console.log(e)
      //   })
      // })
      // .catch(e => console.log(e))
    }
  },
  created() {
    this.listarCrmPropostas(this.dataPagina);
    this.debouncedPesquisar = _.debounce(this.pesquisar, 300);
  },
};
</script>